import * as Yup from 'yup';

export const ValidationSchema = Yup.object({
    sensor_id: Yup.string().required('Sensor id required'),
    model: Yup.object().required('Model required'),
})

